import React, { useCallback } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { toast } from 'react-toastify';
import { Typography } from '@material-ui/core';
import { IScheduleDTO } from '../../../../shared/interfaces/schedule-interfaces';
import { useDeleteSchedule } from '../../../../hooks/data/schedules';
import LoadingButton from '../../../../components/LoadingButton';

type IProps = {
  open: boolean;
  handleClose: () => void;
  schedule: IScheduleDTO;
};

const ScheduleDeleteDialog: React.FC<IProps> = ({
  open,
  handleClose,
  schedule,
}) => {
  const deleteSchedule = useDeleteSchedule({ id: schedule.id! });

  const handleSubmit = useCallback(async () => {
    try {
      await deleteSchedule.mutateAsync({});

      handleClose();
      toast.success('Horário excluído com sucesso');
    } catch (err) {
      toast.error('Erro ao excluir horário');
    }
  }, [deleteSchedule, handleClose]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        Deseja excluir o horário?
      </DialogTitle>
      <DialogContent>
        <Typography>{`Período: ${schedule.start_date} a ${schedule.end_date} `}</Typography>
        <Typography>{`Horário: ${schedule.start_time} a ${schedule.end_time}`}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="primary"
          disabled={deleteSchedule.isLoading}
        >
          Cancelar
        </Button>
        <LoadingButton
          loading={deleteSchedule.isLoading}
          onClick={handleSubmit}
          color="primary"
          variant="contained"
        >
          Excluir
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export { ScheduleDeleteDialog };
